import api from '@/api';

export default {
    namespaced: true,

    state: {},

    actions: {

        async createOrder(context, item) {
            let url = `/api/v1/orders/create`;
            const response = await api.request('post', url, item);
            return response.data;
        },

        async captureOrder(context, item) {
            let url = `/api/v1/orders/${item.order_id}/capture`;
            const response = await api.request('post', url, item);
            return response.data;
        },

        async getPricing(context, item) {
            let url = `/api/v1/orders/pricing?country_code=${item.countryCode}`;
            const response = await api.request('get', url, item);
            return response.data;
        },

        async getCountryByIp(context, item) {
            let url = `/users/countryCodeByIp`;
            const response = await api.request('get', url, item);
            return response.data;
        },

        async getActivePlans(context, item) {
            let url = `/admin/plans`;
            const response = await api.request('get', url, item);
            return response.data;
        },

        async createSubscription(context, {planId, data}) {
            let url = `/admin/plans/${planId}/subscriptions`;
            const response = await api.request('post', url, data);
            return response.data;
        },

        async getSubscriptionLink(context, tag) {
            let url = `/paypal/subscriptions/templates/${encodeURIComponent(tag)}/pay`;
            const response = await api.request('post', url);
            return response.data;
        },
    },
    mutations: {}
};